export default "__VITE_ASSET__DrUfrsH7__"